<div class="loader-wrapper">
  <ng-lottie
    [options]="options"
    style="width: 250px; height: 250px;"
  ></ng-lottie>

  <!-- <div class="loading-text">Loading...</div> -->
</div>